const roleDesignationTransformer = ({ role = '', designation = '' }) => ({
  designation: role,
  designationDisplayName: designation,
});
export default roleDesignationTransformer;
